import React, { useMemo } from 'react';

import { getProviderDetailsAction } from '@/domain/paySettings/actions';

import useDispatchAction from '@/hooks/useDispatchAction';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import AccountDetails from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/DetailsTab/components/AccountDetails';

interface DetailsTabProps {
  id: string;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ id }) => {
  const payload = useMemo(() => ({ id }), [id]);

  const { data, isLoading } = useDispatchAction(getProviderDetailsAction, payload);

  return (
    <Stack direction="row" spacing={3} height="100%">
      <Box component={Paper} p={3} minWidth={400}>
        <AccountDetails data={data} isLoading={isLoading} />
      </Box>

      <Box sx={{ flexGrow: 2, my: '24px !important' }}>
        <Stack component={Paper} height="100%" justifyContent="center" alignItems="center">
          NO TRANSACTIONS YET
        </Stack>
      </Box>
    </Stack>
  );
};

export default DetailsTab;
